export const initFormikValuesType = {
  approver: '',
  comment: '',
};
